import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  image?: string;
  type?: 'website' | 'article';
  keywords?: string;
}

const defaultMeta = {
  title: 'Solved Media | Data, Leads, AI & Consultancy',
  description: 'Data, Leads, AI & Consultancy without the bullshit. Honest, direct, and fully committed to delivering real results.',
  image: '/favicon.webp',
  keywords: 'data services, lead generation, AI solutions, business consultancy, automation, web development, digital marketing',
};

export const SEO = ({
  title,
  description = defaultMeta.description,
  canonical,
  image = defaultMeta.image,
  type = 'website',
  keywords = defaultMeta.keywords,
}: SEOProps) => {
  const fullTitle = title 
    ? `${title} | Solved Media` 
    : defaultMeta.title;
  
  const siteUrl = 'https://solvedmedia.co.uk';
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const imageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="Solved Media" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="Solved Media" />
      <meta property="og:locale" content="en_GB" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:site" content="@solved_media" />
    </Helmet>
  );
};
